const Section = ({ title }) => {
  return(
    <div className="ltr:text-left border-b border-gray-200 pb-5 pt-32">
      <h3 className="text-2xl text-center font-semibold leading-6 text-gray-900">{title}</h3>
    </div>
  )
}
export default Section;